





































import { Observer } from "mobx-vue";
import { Component, Vue } from "vue-property-decorator";
import RequestStatusIcon from "@/components/Requests/RequestStatusIcon.vue";
import RequestTaskStatusIcon from "@/components/Requests/RequestTaskStatusIcon.vue";
import ButtonImageCarousel from "../ExpandableImage/ButtonImageCarousel.vue";
import mapStore from "@/store/mapStore";
import userStore from "@/store/userStore";
import FormattedAddress from "@/components/Address/FormattedAddress.vue";
import format from "date-fns/format";
import isSameDay from "date-fns/isSameDay";
import { DATE_FORMAT } from "@/Constants";

@Observer
@Component({ components: { RequestTaskStatusIcon, RequestStatusIcon, ButtonImageCarousel, FormattedAddress } })
export default class SelectedAddressSummary extends Vue {
  mapStore = mapStore;
  userStore = userStore;

  get lastCollectionEventDate() {
    return mapStore.userSelectedAddressGeocode?.lastCollectionEventDate ? format(new Date(mapStore.userSelectedAddressGeocode.lastCollectionEventDate), DATE_FORMAT) : "Unknown";
  }

  get canChangeCollectionDate() {
    if (!mapStore.userSelectedAddressGeocode?.lastCollectionEventDate) {
      return false;
    }

    return !isSameDay(new Date(mapStore.date), new Date(mapStore.userSelectedAddressGeocode.lastCollectionEventDate));
  }

  updateSelectedDate() {
    if (mapStore.userSelectedAddressGeocode?.lastCollectionEventDate) {
      mapStore.date = format(new Date(mapStore.userSelectedAddressGeocode.lastCollectionEventDate), "yyyy-MM-dd");
    }
  }
}
